<template>
  <div
    v-bind="$attrs"
    class="badge"
    :class="classes"
  >
    <span
      v-if="icon"
      class="icon"
    >
      <SvgIcon
        :data="icon"
        class="icon"
        height="0.9em"
        width="0.9em"
      />
    </span>
    <span class="text">
      <slot />
    </span>
    <span
      v-if="isCloseable"
      class="close-icon"
      @click.prevent="close"
    >
      <SvgIcon :data="require('@icons/streamline-icons/Outline version/01-Interface Essential/43-Remove-Add/remove.svg')" />
    </span>
  </div>
</template>

<script>
import colorHandler from '@/mixins/themeSupport';
import button from '@/components/common/button/mixin/button';

export default {
  name: 'NorticBadge',
  mixins: [colorHandler(), button],
  inheritAttrs: false,
  props: {
    icon: {
      type: [String, Object],
      default: null,
    },
    isCloseable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/components/common/theme-support/themeSupport';

  .badge {
    @include applyThemes($themeTypes, false);

    & > .badge {
      margin-right: 0.5em;
    }

    min-width: 10px;
    justify-content: center;
    font-size: 0.8em;
    display: inline-flex;
    width: auto;
    border-radius: 0.25rem;
    padding: 0.25em 0.4em;
    align-items: center;

    &.rounded {
      border-radius: 10rem;
    }

    &.stroked {
      border-color: var(--border-color-hex);
    }

    .text {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon {
      position: relative;
      left: -0.3em;
      margin-right: 0.2em;
      margin-left: 0.3em;
    }

    .close-icon {
      background: inherit;
      border-radius: 50%;
      cursor: pointer;
      margin-left: 0.5em;
    }
  }
</style>
